const $tabs = $('.tab-system_tabs__tab');
const $contents = $('.tab-system_content__image');

function activateTab(index) {
  $tabs.removeClass('active');
  $contents.hide();

  $tabs.eq(index).addClass('active');
  $contents.eq(index).show();
}

$tabs.on('click', function() {
  const index = $(this).index();
  activateTab(index);
});

activateTab(0);
